// import { Link, useSearchParams } from "react-router-dom";

// export default function PaymentStatus() {
//   const [searchParams] = useSearchParams();
//   const status = searchParams.get("status");
//   const isSuccess = status === "success";

//   return (
//     <div className="pt-20 min-h-screen bg-amber-50 flex items-center justify-center px-6">
//       <div className="max-w-2xl bg-white rounded-lg shadow-lg p-10 text-center">
//         <div className="text-6xl mb-4">
//           {isSuccess ? "" : "⚠️"}
//         </div>

//         <h1
//           className={`text-4xl font-bold mb-4 ${
//             isSuccess
//               ? "text-green-700"
//               : "text-red-600"
//           }`}
//         >
//           {isSuccess
//             ? "Thank You for Your Membership! We welcome you onboard on our seva journey"
//             : "Payment Could Not Be Completed"}
//         </h1>

//         <p className="text-gray-700 text-lg leading-relaxed mb-6">
//           {isSuccess
//              ? "Your membership will help us provide nutritious meals to families and individuals in need."
//              : "We were unable to confirm your membership. No worries — you can try again using the secure membership form."}
//         </p>

//         <div className="bg-amber-50 border border-amber-200 rounded-lg p-5 mb-6">
//           <p className="text-amber-900 font-semibold">
//             BSM Bhojan Seva Mandal Foundation
//           </p>
//           <p className="text-amber-700 mt-2">
//             {isSuccess
//                  ? "Every membership brings food, dignity and hope to someone who needs it most."
//                  : "Your support means a lot to us. If the payment failed, please try again or contact us for assistance."}
//           </p>
//         </div>

//         {isSuccess ? (
//           <div className="bg-green-50 border border-green-200 rounded-lg p-4 mb-6">
//             <p className="text-green-700 text-sm">
//               A confirmation email will be sent for your successful membership. If you do not receive it within 24 hours, please check your spam folder or contact us.
//             </p>
//           </div>
//         ) : (
//           <div className="bg-red-50 border border-red-200 rounded-lg p-4 mb-6">
//             <p className="text-red-700 text-sm">
//               If money was deducted but you do not receive confirmation,
//               please contact us and we will help verify the transaction.
//             </p>
//           </div>
//         )}

//         <div className="space-y-3">
//           {!isSuccess && (
//             <Link
//               to="/membership"
//               className="inline-block bg-orange-600 hover:bg-orange-700 text-white px-6 py-3 rounded-lg font-medium"
//             >
//               Try Donation Again
//             </Link>
//           )}

//           <div>
//             <Link
//               to="/"
//               className="inline-block bg-orange-600 hover:bg-orange-700 text-white px-6 py-3 rounded-lg font-medium"
//             >
//               Return To Homepage
//             </Link>
//           </div>

//           <div>
//             <Link
//               to="/about"
//               className="text-orange-600 hover:text-orange-700"
//             >
//               Learn More About Our Mission
//             </Link>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// }

import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";

const API_BASE =
    process.env.REACT_APP_API_URL || "http://localhost:8000";

export default function PaymentStatus() {
    const [loading, setLoading] = useState(true);
    const [isSuccess, setIsSuccess] = useState(false);

    useEffect(() => {
        const subscriptionId =
            localStorage.getItem("subscriptionId");

        if (!subscriptionId) {
            setLoading(false);
            return;
        }
        let attempts = 0;
        const maxAttempts = 12;
        const interval = setInterval(async () => {
            attempts++;

            try {
                const response = await fetch(
                    `${API_BASE}/payment/subscription/status/${subscriptionId}`
                );

                const data = await response.json();
                if (!response.ok) {
                    throw new Error(data.detail);
                }

                console.log(data);

                /**
                 * Razorpay subscription states:
                 *
                 * created
                 * authenticated
                 * active
                 * pending
                 * cancelled
                 * completed
                 */

                if (
                    data.status === "active" ||
                    data.status === "authenticated"
                ) {
                    setIsSuccess(true);
                    clearInterval(interval);
                    localStorage.removeItem("subscriptionId");
                    setLoading(false);
                    return;
                }

                if (
                    data.status === "cancelled" ||
                    data.status === "completed"
                ) {
                    setIsSuccess(false);
                    clearInterval(interval);
                    localStorage.removeItem("subscriptionId");
                    setLoading(false);
                    return;
                }
                if (attempts >= maxAttempts) {
                    clearInterval(interval);
                    setLoading(false);
                }
            }
            catch (err) {
                console.error(err);
                clearInterval(interval);
                setLoading(false);
            }
        }, 5000);
        return () => clearInterval(interval);
    }, []);

    if (loading) {
        return (
            <div className="pt-20 min-h-screen bg-amber-50 flex items-center justify-center">
                <div className="bg-white p-10 rounded-lg shadow-lg text-center">
                    <div className="animate-spin rounded-full h-14 w-14 border-b-2 border-orange-600 mx-auto mb-5"></div>
                    <h2 className="text-2xl font-semibold text-amber-900">
                        Verifying your payment...
                    </h2>
                    <p className="text-gray-600 mt-3">
                        Please wait while we confirm your subscription with Razorpay.
                    </p>
                </div>
            </div>
        );
    }

    return (
        <div className="pt-20 min-h-screen bg-amber-50 flex items-center justify-center px-6">
            <div className="max-w-2xl bg-white rounded-lg shadow-lg p-10 text-center">
                <div className="text-6xl mb-4">
                    {isSuccess ? "🎉" : "⚠️"}
                </div>

                <h1
                    className={`text-4xl font-bold mb-4 ${
                        isSuccess
                            ? "text-green-700"
                            : "text-red-600"
                    }`}
                >
                    {isSuccess
                        ? "Thank You for Your Membership!"
                        : "Payment Could Not Be Confirmed"}
                </h1>

                <p className="text-gray-700 text-lg leading-relaxed mb-6">
                    {isSuccess
                        ? "Your recurring membership has been successfully registered. Thank you for joinin!."
                        : "We could not verify your payment yet. If money has been deducted, please don't worry. It may take a few moments for Razorpay to activate the subscription."}
                </p>

                <div className="bg-amber-50 border border-amber-200 rounded-lg p-5 mb-6">
                    <p className="text-amber-900 font-semibold">BSM Bhojan Seva Mandal Foundation</p>
                    <p className="text-amber-700 mt-2">
                        {isSuccess
                            ? "Every monthly membership helps us support journal publishing and community knowledge sharing."
                            : "If your payment has been deducted, please contact us if this page does not update within a few minutes."}
                    </p>
                </div>

                {!isSuccess && (
                    <Link
                        to="/membership"
                        className="inline-block bg-orange-600 hover:bg-orange-700 text-white px-6 py-3 rounded-lg font-medium mb-4"
                    >
                        Try Again
                    </Link>
                )}

                <div>
                    <Link
                        to="/"
                        className="inline-block bg-orange-600 hover:bg-orange-700 text-white px-6 py-3 rounded-lg font-medium"
                    >
                        Return Home
                    </Link>
                </div>
            </div>
        </div>
    );
}